/**
 * visualMap component entry
 */


    require('./visualMapContinuous');
    require('./visualMapPiecewise');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/visualMap.js
// module id = 1287
// module chunks = 158